export enum PasswordValidation {
  Required = "required",
  MinLength = "minlength",
  MaxLength = "maxlength",
  Uppercase = "uppercase",
  Lowercase = "lowercase",
  Numbers = "numbers",
  NonAlphas = "nonAlphas",
}
